import { Component } from '@metaverse-systems/libecs-js';

class DrawingComponent extends Component
{
  constructor(config) {
    super(config);
    this.color = config.color;
    this.Type = "DrawingComponent";
  }
}

class PositionComponent extends Component
{
  constructor(config) {
    super(config);
    this.x = config.x;
    this.y = config.y;
    this.Type = "PositionComponent";
  }
}

class VisibleComponent extends Component
{
  constructor(config) {
    super(config);
    this.Type = "VisibleComponent";
  }
}

export {
  DrawingComponent,
  PositionComponent,
  VisibleComponent
};
